/**
 * Initialisateur simple pour SmartChatbot
 * Remplace les anciens initialisateurs supprimés lors du nettoyage
 */

import React from 'react';
import { createRoot } from 'react-dom/client';
import SmartChatbot from './SmartChatbot';

// Configuration par défaut
const defaultConfig = {
  openaiApiKey: 'configured', // Utilise la clé de l'environnement
  position: 'bottom-right' as const,
  theme: 'light' as const,
  autoInit: true
};

// Variable pour stocker la configuration
let chatbotConfig = { ...defaultConfig };

// Fonction d'initialisation avec configuration optionnelle
const initSmartChatbot = (config = {}) => {
  try {
    console.log('🤖 Initialisation SmartChatbot...');
    
    // Fusionner la configuration
    chatbotConfig = { ...defaultConfig, ...config };
    
    // Vérifier si déjà initialisé
    if (document.getElementById('smart-chatbot-container')) {
      console.log('⚠️ SmartChatbot déjà initialisé');
      return;
    }

    // Créer le conteneur
    const container = document.createElement('div');
    container.id = 'smart-chatbot-container';
    document.body.appendChild(container);

    // Créer la racine React 18
    const root = createRoot(container);
    
    // Rendre le composant SmartChatbot avec la configuration
    root.render(React.createElement(SmartChatbot, chatbotConfig));
    
    console.log('✅ SmartChatbot initialisé avec succès !', chatbotConfig);
    
  } catch (error) {
    console.error('❌ Erreur initialisation SmartChatbot:', error);
  }
};

// Auto-initialisation quand le DOM est prêt
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSmartChatbot);
} else {
  // DOM déjà prêt
  initSmartChatbot();
}

// Attacher une API minimale au window pour contrôle manuel (optionnel)
try {
  (window as any).WONChatbot = (window as any).WONChatbot || {};
  (window as any).WONChatbot.init = initSmartChatbot;
} catch (_) {}

// Export pour utilisation manuelle si nécessaire
export default { init: initSmartChatbot };
